import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

// UI
import { Button, Skeleton, Input, Col, Tooltip, Form } from "antd";
import { PlusOutlined, SearchOutlined } from "@ant-design/icons";
import {
  HomePageHeader,
  HeaderLeftItemsWrapper,
  HeaderRightItemsWrapper,
  HeaderRightItem,
} from "../../Common/UIElements";
import CustomerDropdown from "../CustomerSelect/CustomerDropdown";

const OnboardingHomePageTopBar = (props) => {
  const { updateSearchMeta } = props;

  const history = useHistory();
  const { customerID } = history.location;
  const [customer, setCustomer] = useState(customerID ?? "");

  useEffect(() => {
    updateSearchMeta(customer, "searchCustomer", ["_id"]);
  }, [customer]);

  return (
    <div className="onboarding-homepage-top-bar">
      <Skeleton loading={false} active>
        <HomePageHeader>
          <Col xxl={22} xl={22} lg={22} md={22} sm={24} xs={24}>
            <Form layout="vertical">
              <HeaderLeftItemsWrapper>
                <Col xxl={6} xl={6} lg={6} md={6} sm={24} xs={24}>
                  <Form.Item label="Customer Name (HMG)">
                    <CustomerDropdown
                      setCustomer={setCustomer}
                      customer={customer}
                    />
                  </Form.Item>
                </Col>
                <Col xxl={6} xl={6} lg={6} md={6} sm={24} xs={24}>
                  <Form.Item label=" ">
                    <Input
                      name="searchAll"
                      prefix={<SearchOutlined />}
                      onChange={(e) => {
                        updateSearchMeta(e.target.value, "searchAll");
                      }}
                      placeholder="Search"
                      allowClear
                    />
                  </Form.Item>
                </Col>
              </HeaderLeftItemsWrapper>
            </Form>
          </Col>
          <Col xxl={2} xl={2} lg={2} md={2} sm={24} xs={24}>
            <HeaderRightItemsWrapper>
              <HeaderRightItem>
                <Tooltip placement="bottomRight" title="Add Customer">
                  <Button
                    onClick={() => {
                      history.push("/onboarding/customer/add");
                    }}
                    type="link"
                    size="large"
                    icon={<PlusOutlined />}
                  >
                    Add Customer
                  </Button>
                </Tooltip>
              </HeaderRightItem>
            </HeaderRightItemsWrapper>
          </Col>
        </HomePageHeader>
      </Skeleton>
    </div>
  );
};

export default OnboardingHomePageTopBar;
